// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"7c41e354","190":"819bfa3f","295":"653a93a9","394":"751fa0b1","744":"fdb95733","787":"6606bfd5","793":"9bbb8e54","817":"7c7ae261","884":"f9a0f033"}[chunkId] + ".chunk.js";
};